import { UsernameRenameWidgetData } from './types';
import { INITIAL_SAVE_REQUEST_META } from '../utils';

export const defaultUsernameRenameWidgetData: UsernameRenameWidgetData['initialData'] =
  {
    username: '',
    password: '',
    isRenameEligible: false,
    hasRecentRename: false,
  };

export const defaultUsernameRenameWidgetState: UsernameRenameWidgetData = {
  initialData: defaultUsernameRenameWidgetData,
  currentData: defaultUsernameRenameWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
};
